export const getPrefixed = (prefix?: string) => (prefix ? `${prefix}.` : '');
